<template>
    <div>
        <card-header title="Registration Search" icon="fa-search" />

        <card-body>
            <card-list>
                <subheader-list-item :title="props.query" icon="fa-align-left" :badge="registrations.length + ' Results'" />
                <regiration-tile
                    :card="card"
                    :registration="registration"
                    v-for="registration in registrations"
                    :active="(child && child.definition.component === 'registration' && registration.id === parseInt(child.props.registrationId))"
                    @click="$openCard('registration', {regId: registration.id, confId: registration.conference_id}, card)"
                />
            </card-list>
        </card-body>

        <card-footer v-if="registrations.length === 100">
            <i class="fas fa-exclamation-triangle mr-2 has-text-warning"></i><strong>There may be more results. </strong>Refine your search criteria.
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SearchListItem from "@/TIER/components/SearchListItem";

    import RegirationTile from "../../../components/tiles/RegistrationTile";

    import {client as http} from '@/http_client';
    import CardFooter from "../../../TIER/components/CardFooter.vue";

    export default {
        components: {CardFooter, CardHeader, CardBody, CardList, RegirationTile, SubheaderListItem, SearchListItem},
        props: ['card', 'child', 'props'],
        data() {
            return {
                conference: {},
                registrations: []
            };
        },
        methods: {
            load: function () {
                http.get('conferences/' + this.props.confId).then(response => {
                    this.conference = response.data;
                });
            },
            searchRegistrations: function () {
                this.$emit('loading', true);
                http.post('registrations/search', {
                    where: {
                        conference_id: this.props.confId,
                        users: {
                            OR: this.props.query.split(' ').map(q => {
                                return {
                                    OR: [
                                        {first_name: {contains: q,},},
                                        {last_name: {contains: q,},},
                                    ],
                                };
                            }),
                        },
                    },
                    select: {
                        id: true,
                        conference_id: true,
                        users: {
                            select: {
                                id: true,
                                first_name: true,
                                last_name: true,
                            },
                        },
                        conf_reg_types: {
                            select: {
                                id: true,
                                title: true,
                            },
                        },
                        reg_applications: {
                            select: {
                                id: true,
                                progress: true,
                                total_minutes: true,
                                total_units: true,
                                is_in_review: true,
                                completed_at: true,
                                created_at: true,
                                conf_applications: {
                                    select: {
                                        applications: {
                                            select: {
                                                id: true,
                                                title: true,
                                            }
                                        }
                                    }
                                }
                            },
                        }
                    },
                    skip: 0,
                    take: 100,
                }).then(response => {
                    this.registrations = response.data;
                    this.$emit('loading', false);
                });
                console.log('us: search registrations: ' + this.props.query);
            }
        },
        watch: {
            'props.query': function (val) {
                this.searchRegistrations();
            }
        },
        mounted: function () {
            this.load();
            this.searchRegistrations();
        },
    }
</script>

<style scoped>
</style>
